// extracted by mini-css-extract-plugin
module.exports = {"article":"index_article__5IuEC"};